module.exports = __webpack_public_path__ + "static/media/floating.979819ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/floating.png
// module id = 48
// module chunks = 0